import styled from 'styled-components';
import { Colors } from '../../../../assets/styles/StyleTypes';

type RowProps = {
  className?: string;
};
export const Row = styled.div<RowProps>`
  cursor: ${(props) => (props.className !== 'cursorPointer' ? 'pointer' : 'default')};
  background-color: ${(props) => props.theme.colors.backgroundTable};
  padding: 8px 20px;
  display: flex;
  align-items: center;
  &:nth-child(even), &.even {
    background-color: transparent;
  }
  &.cursorPointer{
    cursor: default;
  }

  &.equipment-table-master{
    @media screen and (max-width: 960px) {
      height: auto;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 10px;
      grid-template-rows: 20px 20px 20px;
      grid-template-areas:
        'data1  data3 data5'
        'data2 data4 data6';
      padding-left: 5px;
      font-size: 13px;
    }
    @media (max-width: 600px) {
      grid-template-columns: 1fr 1fr 10px;
      grid-template-rows: 20px 20px 20px 20px;
      grid-template-areas:
        'data1 data4'
        'data2 data5'
        'data3 data6';
    }
  }

  &.equipment-table{
    @media screen and (max-width: 960px) {
      height: auto;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 10px;
      grid-template-rows: 20px 20px 20px;
      grid-template-areas:
        'title data4 data8 more-button'
        'data1 data5 data9 data'
        'data2 data6 data10 data'
        'data3 data7 data11 data';
      padding-left: 5px;
      font-size: 13px;
    }
    @media (max-width: 600px) {
      grid-template-columns: 1fr 1fr 10px;
      grid-template-rows: 20px 20px 20px 20px;
      grid-template-areas:
        'title data4 more-button'
        'data1 data5 data'
        'data2 data6 data'
        'data3 data7 data'
        'data10 data8 data'
        'data9 data11 data';
    }
  }

  &.equipment-table-suport{
    @media screen and (max-width: 960px) {
      height: auto;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 10px;
      grid-template-rows: 20px 20px 20px;
      grid-template-areas:
        'title data4 data8 more-button'
        'data1 data5 data9 data'
        'data2 data6 data data'
        'data3 data7 data data';
      padding-left: 5px;
      font-size: 13px;
    }
    @media (max-width: 600px) {
      grid-template-columns: 1fr 1fr 10px;
      grid-template-rows: 20px 20px 20px 20px;
      grid-template-areas:
        'title data4 more-button'
        'data1 data5 data'
        'data2 data6 data'
        'data3 data7 data'
        'data10 data8 data'
        'data9 data11 data';
    }
  }

  @media screen and (max-width: 960px) {
    height: auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 10px;
    grid-template-rows: 20px 20px 20px;
    grid-template-areas:
      'title title data2 more-button'
      'data1 data5 data3 data3'
      'data4 data6 data7 data7';
    padding-left: 5px;
    font-size: 13px;

    &#table-equipments {
      grid-template-columns: 0.5fr 1.5fr 1fr 1fr 1fr 0;
      grid-template-rows: 20px;
      grid-template-areas:
        'title data1 data2 data3 data4';

      @media screen and (max-width: 500px) {
        padding: 8px 0px;
        grid-template-columns: 0.7fr 1fr 1fr 1fr 1fr 0;
      }
    }

    &#table-equipments-home {
      grid-template-columns: 0.7fr 1.4fr 1fr 0.5fr 0 0;
      grid-template-rows: 20px;
      grid-template-areas:
        'title data1 data2 data5 data3 data4';
    }
    &#table-equipments-errorSerious {
      grid-template-columns: 1fr 1fr 1.8fr 1.8fr 3fr;
      grid-template-rows: 20px;
      grid-template-areas:
        'title data1 data2 data3 data4'
    }
    &#table-update-equipments {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
      grid-template-rows: 20px;
      grid-template-areas:
        'title data1 data2 data3 data4 data5'
    }
    &#recipes-executions {
      grid-template-columns: 3fr 2fr 1fr 2fr 1fr;
      grid-template-rows: 20px;
      grid-template-areas:
        'title data1 data2 data3 data4'
    }
    &#cleaning-executions {
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 20px;
      grid-template-areas:
        'date hour'
    }
    &#details-equipment {
      grid-template-columns: 3fr 1fr 1fr;
      grid-template-rows: 20px;
      grid-template-areas:
        'title data1 hour'
    }
    &#table-equipments-support {
      grid-template-columns: 1fr 1fr 1fr 10px;
      grid-template-rows: 20px 20px 20px;
      grid-template-areas:
        'title data2 more-button'
        'data1 data5 data3 data9'
        'data4 data6 data7 data8';
    }
  }
  
  @media (max-width: 600px) {
    grid-template-columns: 1fr 1fr 10px;
    grid-template-rows: 20px 20px 20px 20px;
    grid-template-areas:
      'title data2 more-button'
      'data1 data3 data3'
      'data4 data5 data5'
      'data6 data7 data7';

      &#details-equipment {
      padding-left: 0px;
      grid-template-columns: 1.8fr 1fr 0.8fr;
      grid-template-rows: 20px;
      grid-template-areas:
        'title data1 hour'
    }
    &#table-equipments-support {
      grid-template-columns: 1fr 1fr 10px;
      grid-template-rows: 20px 20px 20px 20px;
      grid-template-areas:
        'title data2 more-button'
        'data1 data3 data3'
        'data4 data5 data9'
        'data6 data7 data8';
    }
  }
  @media (max-width: 420px) {
      &#details-equipment {
      padding-left: 0px;
      grid-template-columns: 1.5fr 1fr 0.8fr;
      grid-template-rows: 20px;
      grid-template-areas:
        'title data1 hour'
    }
  }
`;
type DataProps = {
  gridArea: string;
  width: string;
};
export const Data = styled.div<DataProps>`
  width: ${(props) => props.width};
  height: 20px;
  text-align: left;
  grid-area: ${(props) => props.gridArea};
  margin-right: 20px;
  text-overflow: ellipsis;
  /* white-space: nowrap; */
  overflow: hidden;

  :hover{
    white-space: normal;
    display: flex;
    align-content: center;
    height: auto;
    word-break: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
  } 
  &.checkbox_table {
    //margin-right: 20px;
    width: 26px;
  }
  &.more-icon {
    overflow: initial;
  }
  img{
    width: 20px;
    margin-right: 20px;
  }
  .mobile-header {
    display: none;
  }


  @media screen and (max-width: 960px) {
    display: block;
    align-items: center;
    width: auto;
    padding-left: 20px;
    margin-right: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
    &.title {
      font: normal normal bold 14px/20px Roboto;
      letter-spacing: 0.2px;
      color: ${(props) => props.theme.colors.textPrimary};
      text-transform: uppercase;
    }
    &.more-icon {
      padding: 0;
    }
    &.checkbox_table {
      padding: 0;
    }
    .mobile-header {
      display: inline;
      font-weight: bold;
    }
    
  }
`;

export const DataIcon = styled.div<DataProps>`
  width: ${(props) => props.width};
  text-align: left;
  grid-area: ${(props) => props.gridArea};
  margin-right: 20px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: normal;
  display: flex;
  align-content: center;

  &#download {
    overflow: visible;
    height: 20px;
    cursor: pointer;
  }

  &#alert{
    overflow: visible;
    height: 20px;
    cursor: pointer;
  }

  &#delete{
    overflow: visible;
    height: 30px;
    cursor: pointer;
  }

  &#edit{
    overflow: visible;
    height: 30px;
    cursor: pointer;
    padding-left: 11px;
  }

  &.checkbox_table {
    //margin-right: 20px;
    width: 22px;
  }
  &.more-icon {
    overflow: initial;
  }
  img{
    margin-right: 20px;
  }

  @media screen and (max-width: 960px) {
    display: flex;
    align-items: center;
    width: auto;
    padding-left: 20px;
    &.title {
      font: normal normal bold 14px/20px Roboto;
      letter-spacing: 0.2px;
      color: ${Colors.LOW_PURE};
      text-transform: uppercase;
    }
    &.more-icon {
      padding: 0;
    }
    &.checkbox_table {
      display: none;
    }
    &#download {
      //display: none;
    }
  }
`;

export const TBody = styled.div<{ hideScrolllbar?: boolean }>`
  width: 100%;
  height: 100%;
  overflow-y: ${props => props.hideScrolllbar ? 'hidden' : 'auto'};
`;

export const Tooltip = styled.div`
  visibility: hidden;
  background-color: white;
  color: #004992;
  text-align: center;
  font-family: Roboto, sans-serif;
  font-weight: bold;
  font-size: 12px;
  border-radius: 6px;
  padding: 5px 10px;
  position: absolute;
  top: -20%;
  right: -45px;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  white-space: nowrap;
 // width: 170px;
  border: 1px solid;
  border-color: #004992;

  &::after {
    content: "";
    position: absolute;
    top: 30%;
    right: 0;
  }
`;

export const IconWrapper = styled.div`
  position: relative;
  display: inline-block;
  overflow: visible;

  &:hover > ${Tooltip} {
    visibility: visible;
    opacity: 1;
  }

  svg {
    fill: #5DAEff;
  }

  @media screen and (max-width: 960px) {
    //display: none;
  }
`;

const colorMap: { [key: string]: string } = {
  'Online': '#31D146',
  'Offline': '#767676',
  'green': '#31D146',
  'blue': '#5DAEFF',
  'grey': '#767676',
  'orange': '#E54529',
  'red': '#C21618',
  'yellow': '#EEAD2D',
  'grey2': '#A6A6A6'
};

export const Ellipse = styled.div<{ status: string }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ status }) => colorMap[status] || 'transparent'};
  display: ${({ status }) => status !== '-' ? 'inline-block' : 'none'};
  margin: 0 5px;
`;

export const StatusText = styled.text`
  text-overflow: ellipsis;
  width: auto;
  @media screen and (max-width: 900px) {
    display: none;
  }
`;

export const StatusTextMenssage = styled.text`
  text-overflow: ellipsis;
  width: auto;
`;